import React from 'react';
import { Link } from 'react-router-dom';

const TopOne = () => {
    return(
        <>
        <div className="header-top">
        <div className="default-container">
            <div className="clearfix">
                <div className="top-left">
                    <ul className="header-info-list">
                        <li><i className="icon fa fa-envelope"></i><strong>Email:</strong> support@example.com</li>
                        <li><i className="icon fa fa-map-marker"></i><strong>Address:</strong> California, TX 70240</li>
                        <li><i className="icon fa fa-headphones"></i><strong>Phone:</strong> +123 456 7890</li>
                    </ul>
                </div>
                <div className="top-right">
                    <ul className="social-box">
                        <li><Link to="#"><i className="fa fa-facebook"></i></Link></li>
                        <li><Link to="#"><i className="fa fa-linkedin"></i></Link></li>
                        <li><Link to="#"><i className="fa fa-vimeo"></i></Link></li>
                        <li><Link to="#"><i className="fa fa-instagram"></i></Link></li>
                        <li><Link to="#"><i className="fa fa-pinterest-p"></i></Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    </>
    )
}

export default TopOne;